<template>
  <div class="app-breadcrumb">
    <div>
      <span
        class="app-breadcrumb__root"
        :class="{ 'app-breadcrumb__root--link': rootClickable }"
        @click="rootClickable && $emit('root-click')"
        >{{ root }}</span
      >
      <span class="app-breadcrumb__sep">/</span>
      <span class="app-breadcrumb__current">{{ current }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AppBreadcrumb',
  props: {
    root: {
      type: String,
      required: true
    },
    current: {
      type: String,
      default: ''
    },
    rootClickable: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
// Colors are literal hex (matching the client's mockup palette), not the
// module-scoped CSS custom properties (--blue, --text, etc.) — this
// component gets dropped into whichever module's shell renders it, and
// shouldn't depend on that shell defining the same variable names.
.app-breadcrumb {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 16px;
  font-size: 13px;

  > div:first-child {
    display: flex;
    align-items: center;
    gap: 6px;
  }
}

.app-breadcrumb__root {
  color: #4b5563;

  &--link {
    color: #2563eb;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.app-breadcrumb__sep {
  color: #9ca3af;
}

.app-breadcrumb__current {
  font-weight: 600;
  color: #111827;
}
</style>
